export default __webpack_public_path__ + "static/media/master.db2b8294.png";